<script>
import { mapGetters, mapMutations } from 'vuex'
import appHeaderFilter__field from '@/components/app-header/app-header-filter__field'
import FiltersIcon from '@/components/common/FiltersIcon.vue'
import AppButton from '@/components/common/app-button.vue'

export default {
  name: "app-header-filter-mobile",
  components: {AppButton, appHeaderFilter__field, FiltersIcon},
  props: {
    options: {
      type: Array,
      default() {
        return []
      }
    },
    currency: {
      type: String,
      default: 'RUB'
    },
    isMobileVersion: Boolean,
    setParams: Function,
    searchToParams: Function,
    searchParams: Array,
    fieldsForAutocomplete: Object
  },
  methods: {
    onClickLoadFiltersButton() {
      this.loadFilters(true)
    },
    onClickCloseFiltersButton() {
      this.loadFilters(false)
    },
    ...mapMutations({
      loadFilters: 'LOAD_FILTERS'
    })
  },
  computed: {
    ...mapGetters({
      isLoadedFilters: 'isLoadedFilters',
      getCatalogConstantTranslationByKey: 'account/getCatalogConstantTranslationByKey',
    }),
    filtersStyles() {
      return this.isLoadedFilters ? '' : 'top-1/2'
    }
  }
};
</script>

<template>
  <div :class="filtersStyles">
    <FiltersIcon
      v-if="!isLoadedFilters"
      @click="onClickLoadFiltersButton"
      class="cursor-pointer border border-grey-light bg-white rounded overflow-hidden h-9"
    />
    
    <div v-else class="flex justify-between">
      <div
        class="h-10 py-2 text-center text-xs whitespace-nowrap"
        @click="$emit('resetFilters')"
      >
        {{ getCatalogConstantTranslationByKey('reset-filter') }}
      </div>
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        class="w-6" 
        fill="none" 
        viewBox="0 0 24 24" 
        stroke="currentColor"
        @click="onClickCloseFiltersButton"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </div>
  </div>

  <div v-if="isLoadedFilters" :class="isLoadedFilters ? 'h-screen' : ''">
    <appHeaderFilter__field
        v-for="optionItem of options"
        :key="optionItem.id"
        :item="optionItem"
        :currency="currency"
        :autocompleteItems="fieldsForAutocomplete"
        :isMobileVersion="isMobileVersion"
        @changeValue="setParams"
        :searchParams="searchParams"
    />
    
    <div class="flex justify-center">
      <div>
        <AppButton
          class="whitespace-nowrap"
          :name="`Показать объявления`"
          @btnClick="onClickCloseFiltersButton"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
  .search-counter {
    left: 3px;
  }
</style>